import type { ConsoleScreenMap } from '../types'
import { lazyScreen } from '../lazyScreen'
const BillingScreen = lazyScreen(() => import('./billing/BillingScreen'), (m) => m.BillingScreen)
const ChildrenScreen = lazyScreen(() => import('./children/ChildrenScreen'), (m) => m.ChildrenScreen)
const ReportsScreen = lazyScreen(() => import('./reports/ReportsScreen'), (m) => m.ReportsScreen)
const TryGamesScreen = lazyScreen(() => import('./games/TryGamesScreen'), (m) => m.TryGamesScreen)
const SettingsScreen = lazyScreen(() => import('./settings/SettingsScreen'), (m) => m.SettingsScreen)
const HelpScreen = lazyScreen(() => import('./help/HelpScreen'), (m) => m.HelpScreen)
const SchoolHomeScreen = lazyScreen(() => import('./home/SchoolHomeScreen'), (m) => m.SchoolHomeScreen)
const ClassesScreen = lazyScreen(() => import('./staff/ClassesScreen'), (m) => m.ClassesScreen)
const TeachersScreen = lazyScreen(() => import('./staff/TeachersScreen'), (m) => m.TeachersScreen)

/**
 * The school tier's redesigned screens, by route. A route listed here is served
 * by the console registry ahead of AppRouter's older switch; a route not
 * listed keeps its existing screen. Owned by the school workstream.
 */
export const SCHOOL_SCREENS: ConsoleScreenMap = {
  school: { component: SchoolHomeScreen },
  'school-subscription': { component: BillingScreen },
  'school-students': { component: ChildrenScreen },
  'school-teachers': { component: TeachersScreen },
  'school-classes': { component: ClassesScreen },
  'school-reports': { component: ReportsScreen },
  /* The old game-activity log, now Reports' second tab (hidden from the nav). */
  'school-games': { component: ReportsScreen },
  'school-try-games': { component: TryGamesScreen },
  'school-settings': { component: SettingsScreen },
  'school-help': { component: HelpScreen },
}
